module.exports = __webpack_public_path__ + "img/one-board.d07ae83a.png";